import { useTranslation } from 'react-i18next'
import { formatCents, type AdminBillingInvoiceDetail } from '../../hooks/use-admin-billing'

const STYLES: Record<string, string> = {
  draft: 'bg-info/10 border-info/30',
  due: 'bg-info/10 border-info/30',
  overdue: 'bg-destructive/10 border-destructive/30 text-destructive',
  paid: 'bg-success/10 border-success/30',
  cancelled: 'bg-muted border-border',
}

/** BillingInvoiceNextStep says in one sentence what the admin does next, from the payment state. */
export function BillingInvoiceNextStep({ invoice }: { invoice: AdminBillingInvoiceDetail }) {
  const { t, i18n } = useTranslation('admin')
  const state = invoice.payment_state in STYLES ? invoice.payment_state : 'cancelled'
  const text = t(`billing.invoices.next_step.${state}`, {
    remaining: formatCents(invoice.remaining_cents, i18n.language),
    due: invoice.due_on ?? '—',
  })
  return (
    <div
      className={`rounded-md border p-4 text-sm ${STYLES[state]}`}
      role="status"
      data-testid="billing-invoice-next-step"
      data-state={state}
    >
      <div className="font-medium">{t('billing.invoices.next_step.title')}</div>
      <div data-testid="billing-invoice-next-step-text">{text}</div>
    </div>
  )
}
